import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../wayfinder'
/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

register.form = registerForm

/**
* @see \App\Http\Controllers\RobotsController::__invoke
* @see app/Http/Controllers/RobotsController.php:10
* @route '/robots.txt'
*/
export const robots = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: robots.url(options),
    method: 'get',
})

robots.definition = {
    methods: ["get","head"],
    url: '/robots.txt',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\RobotsController::__invoke
* @see app/Http/Controllers/RobotsController.php:10
* @route '/robots.txt'
*/
robots.url = (options?: RouteQueryOptions) => {
    return robots.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\RobotsController::__invoke
* @see app/Http/Controllers/RobotsController.php:10
* @route '/robots.txt'
*/
robots.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: robots.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RobotsController::__invoke
* @see app/Http/Controllers/RobotsController.php:10
* @route '/robots.txt'
*/
robots.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: robots.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\RobotsController::__invoke
* @see app/Http/Controllers/RobotsController.php:10
* @route '/robots.txt'
*/
const robotsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: robots.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RobotsController::__invoke
* @see app/Http/Controllers/RobotsController.php:10
* @route '/robots.txt'
*/
robotsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: robots.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RobotsController::__invoke
* @see app/Http/Controllers/RobotsController.php:10
* @route '/robots.txt'
*/
robotsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: robots.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

robots.form = robotsForm

/**
* @see \App\Http\Controllers\CardShowController::__invoke
* @see app/Http/Controllers/CardShowController.php:14
* @route '//transylvaniacardexpo.com'
*/
export const cardExpoSite = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cardExpoSite.url(options),
    method: 'get',
})

cardExpoSite.definition = {
    methods: ["get","head"],
    url: '//transylvaniacardexpo.com',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CardShowController::__invoke
* @see app/Http/Controllers/CardShowController.php:14
* @route '//transylvaniacardexpo.com'
*/
cardExpoSite.url = (options?: RouteQueryOptions) => {
    return cardExpoSite.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CardShowController::__invoke
* @see app/Http/Controllers/CardShowController.php:14
* @route '//transylvaniacardexpo.com'
*/
cardExpoSite.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cardExpoSite.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CardShowController::__invoke
* @see app/Http/Controllers/CardShowController.php:14
* @route '//transylvaniacardexpo.com'
*/
cardExpoSite.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cardExpoSite.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CardShowController::__invoke
* @see app/Http/Controllers/CardShowController.php:14
* @route '//transylvaniacardexpo.com'
*/
const cardExpoSiteForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cardExpoSite.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CardShowController::__invoke
* @see app/Http/Controllers/CardShowController.php:14
* @route '//transylvaniacardexpo.com'
*/
cardExpoSiteForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cardExpoSite.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CardShowController::__invoke
* @see app/Http/Controllers/CardShowController.php:14
* @route '//transylvaniacardexpo.com'
*/
cardExpoSiteForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: cardExpoSite.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

cardExpoSite.form = cardExpoSiteForm

/**
* @see \App\Http\Controllers\Shop\HomeController::__invoke
* @see app/Http/Controllers/Shop/HomeController.php:23
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\HomeController::__invoke
* @see app/Http/Controllers/Shop/HomeController.php:23
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\HomeController::__invoke
* @see app/Http/Controllers/Shop/HomeController.php:23
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\HomeController::__invoke
* @see app/Http/Controllers/Shop/HomeController.php:23
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\HomeController::__invoke
* @see app/Http/Controllers/Shop/HomeController.php:23
* @route '/'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\HomeController::__invoke
* @see app/Http/Controllers/Shop/HomeController.php:23
* @route '/'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\HomeController::__invoke
* @see app/Http/Controllers/Shop/HomeController.php:23
* @route '/'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see \App\Http\Controllers\Shop\SearchController::__invoke
* @see app/Http/Controllers/Shop/SearchController.php:31
* @route '/search'
*/
export const search = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

search.definition = {
    methods: ["get","head"],
    url: '/search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\SearchController::__invoke
* @see app/Http/Controllers/Shop/SearchController.php:31
* @route '/search'
*/
search.url = (options?: RouteQueryOptions) => {
    return search.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\SearchController::__invoke
* @see app/Http/Controllers/Shop/SearchController.php:31
* @route '/search'
*/
search.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\SearchController::__invoke
* @see app/Http/Controllers/Shop/SearchController.php:31
* @route '/search'
*/
search.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: search.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\SearchController::__invoke
* @see app/Http/Controllers/Shop/SearchController.php:31
* @route '/search'
*/
const searchForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\SearchController::__invoke
* @see app/Http/Controllers/Shop/SearchController.php:31
* @route '/search'
*/
searchForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\SearchController::__invoke
* @see app/Http/Controllers/Shop/SearchController.php:31
* @route '/search'
*/
searchForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

search.form = searchForm

/**
* @see \App\Http\Controllers\Shop\PreorderController::__invoke
* @see app/Http/Controllers/Shop/PreorderController.php:18
* @route '/preorders'
*/
export const preorders = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: preorders.url(options),
    method: 'get',
})

preorders.definition = {
    methods: ["get","head"],
    url: '/preorders',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\PreorderController::__invoke
* @see app/Http/Controllers/Shop/PreorderController.php:18
* @route '/preorders'
*/
preorders.url = (options?: RouteQueryOptions) => {
    return preorders.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\PreorderController::__invoke
* @see app/Http/Controllers/Shop/PreorderController.php:18
* @route '/preorders'
*/
preorders.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: preorders.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PreorderController::__invoke
* @see app/Http/Controllers/Shop/PreorderController.php:18
* @route '/preorders'
*/
preorders.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: preorders.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\PreorderController::__invoke
* @see app/Http/Controllers/Shop/PreorderController.php:18
* @route '/preorders'
*/
const preordersForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preorders.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PreorderController::__invoke
* @see app/Http/Controllers/Shop/PreorderController.php:18
* @route '/preorders'
*/
preordersForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preorders.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\PreorderController::__invoke
* @see app/Http/Controllers/Shop/PreorderController.php:18
* @route '/preorders'
*/
preordersForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preorders.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

preorders.form = preordersForm

/**
* @see \App\Http\Controllers\Shop\ExclusiveController::__invoke
* @see app/Http/Controllers/Shop/ExclusiveController.php:23
* @route '/exclusive'
*/
export const exclusive = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exclusive.url(options),
    method: 'get',
})

exclusive.definition = {
    methods: ["get","head"],
    url: '/exclusive',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Shop\ExclusiveController::__invoke
* @see app/Http/Controllers/Shop/ExclusiveController.php:23
* @route '/exclusive'
*/
exclusive.url = (options?: RouteQueryOptions) => {
    return exclusive.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Shop\ExclusiveController::__invoke
* @see app/Http/Controllers/Shop/ExclusiveController.php:23
* @route '/exclusive'
*/
exclusive.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exclusive.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\ExclusiveController::__invoke
* @see app/Http/Controllers/Shop/ExclusiveController.php:23
* @route '/exclusive'
*/
exclusive.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exclusive.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Shop\ExclusiveController::__invoke
* @see app/Http/Controllers/Shop/ExclusiveController.php:23
* @route '/exclusive'
*/
const exclusiveForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exclusive.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\ExclusiveController::__invoke
* @see app/Http/Controllers/Shop/ExclusiveController.php:23
* @route '/exclusive'
*/
exclusiveForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exclusive.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Shop\ExclusiveController::__invoke
* @see app/Http/Controllers/Shop/ExclusiveController.php:23
* @route '/exclusive'
*/
exclusiveForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exclusive.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exclusive.form = exclusiveForm
